import React from 'react';
import PageHeader from '../PageHeader';

import _ from '@ihme/common/locale';
import locale from './locale';

const AboutScene = () => (
    <div style={styles.container}>
        <PageHeader style={styles.header}>{_(locale.title)}</PageHeader>
        <div dangerouslySetInnerHTML={{ __html: _(locale.text) }} />
    </div>
);

const styles = {
    header: {
        paddingLeft: 0,
    },
    container: {
        maxWidth: 540,
        margin: '0 auto',
    },
};

export default AboutScene;
